<script type="text/javascript">
  const Constants = {
    RSA_PUBLIC_KEY: 'rsaPublicKey'
    , ACCESS_TOKEN: 'accessToken'
    , LOGIN_STATE: 'loginState'
    ,BASE_URL :process.env.API_HOST
    ,PAGE_SIZES :10
  };
  export default Constants
</script>



// WEBPACK FOOTER //
// src/components/Constants.vue